import { AgGridTranslations } from '@copado/cds';

export const translations = (): AgGridTranslations => ({
  addCurrentSelectionToFilter: $localize`Add current selection to filter`,
  addToLabels: $localize`Add \${variable} to labels`,
  addToValues: $localize`Add \${variable} to values`,
  advancedFilterAnd: $localize`AND`,
  advancedFilterApply: $localize`Apply`,
  advancedFilterBlank: $localize`is blank`,
  advancedFilterBuilder: $localize`Builder`,
  advancedFilterBuilderAddButtonTooltip: $localize`Add Filter or Group`,
  advancedFilterBuilderAddCondition: $localize`Add Filter`,
  advancedFilterBuilderAddJoin: $localize`Add Group`,
  advancedFilterBuilderApply: $localize`Apply`,
  advancedFilterBuilderCancel: $localize`Cancel`,
  advancedFilterBuilderEnterValue: $localize`Enter a value...`,
  advancedFilterBuilderMoveDownButtonTooltip: $localize`Move Down`,
  advancedFilterBuilderMoveUpButtonTooltip: $localize`Move Up`,
  advancedFilterBuilderRemoveButtonTooltip: $localize`Remove`,
  advancedFilterBuilderSelectColumn: $localize`Select a column`,
  advancedFilterBuilderSelectOption: $localize`Select an option`,
  advancedFilterBuilderTitle: $localize`Advanced Filter`,
  advancedFilterBuilderValidationAlreadyApplied: $localize`Current filter already applied.`,
  advancedFilterBuilderValidationEnterValue: $localize`Must enter a value.`,
  advancedFilterBuilderValidationIncomplete: $localize`Not all conditions are complete.`,
  advancedFilterBuilderValidationSelectColumn: $localize`Must select a column.`,
  advancedFilterBuilderValidationSelectOption: $localize`Must select an option.`,
  // Advanced Filter
  advancedFilterContains: $localize`contains`,
  advancedFilterEndsWith: $localize`ends with`,
  advancedFilterEquals: $localize`=`,
  advancedFilterFalse: $localize`is false`,
  advancedFilterGreaterThan: $localize`>`,
  advancedFilterGreaterThanOrEqual: $localize`>=`,
  advancedFilterLessThan: $localize`<`,
  advancedFilterLessThanOrEqual: $localize`<=`,
  advancedFilterNotBlank: $localize`is not blank`,
  advancedFilterNotContains: $localize`does not contain`,
  advancedFilterNotEqual: $localize`!=`,
  advancedFilterOr: $localize`OR`,
  advancedFilterStartsWith: $localize`begins with`,
  advancedFilterTextEquals: $localize`equals`,
  advancedFilterTextNotEqual: $localize`does not equal`,
  advancedFilterTrue: $localize`is true`,
  advancedFilterValidationExtraEndBracket: $localize`Too many end brackets`,
  advancedFilterValidationInvalidColumn: $localize`Column not found`,
  advancedFilterValidationInvalidDate: $localize`Value is not a valid date`,
  advancedFilterValidationInvalidJoinOperator: $localize`Join operator not found`,
  advancedFilterValidationInvalidOption: $localize`Option not found`,
  advancedFilterValidationJoinOperatorMismatch: $localize`Join operators within a condition must be the same`,
  advancedFilterValidationMessage: $localize`Expression has an error. \${variable} - \${variable}.`,
  advancedFilterValidationMessageAtEnd: $localize`Expression has an error. \${variable} at end of expression.`,
  advancedFilterValidationMissingColumn: $localize`Column is missing`,
  advancedFilterValidationMissingCondition: $localize`Condition is missing`,
  advancedFilterValidationMissingEndBracket: $localize`Missing end bracket`,
  advancedFilterValidationMissingOption: $localize`Option is missing`,
  advancedFilterValidationMissingQuote: $localize`Value is missing an end quote`,
  advancedFilterValidationMissingValue: $localize`Value is missing`,
  advancedFilterValidationNotANumber: $localize`Value is not a number`,
  advancedSettings: $localize`Advanced Settings`,
  after: $localize`After`,
  aggregate: $localize`Aggregate`,
  // Filter Conditions
  andCondition: $localize`AND`,
  animation: $localize`Animation`,
  // Filter Buttons
  applyFilter: $localize`Apply`,
  april: $localize`April`,
  area: $localize`Area`,
  areaChart: $localize`Area`,
  AreaColumnCombo: $localize`Area & Column`,
  areaColumnComboTooltip: $localize`Area & Column`,
  areaGroup: $localize`Area`,
  ariaAdvancedFilterBuilderColumn: $localize`Column`,
  ariaAdvancedFilterBuilderFilterItem: $localize`Filter Condition`,
  ariaAdvancedFilterBuilderGroupItem: $localize`Filter Group`,
  // ARIA
  ariaAdvancedFilterBuilderItem: $localize`\${variable}. Level \${variable}. Press ENTER to edit`,
  ariaAdvancedFilterBuilderItemValidation: $localize`\${variable}. Level \${variable}. \${variable} Press ENTER to edit`,
  ariaAdvancedFilterBuilderJoinOperator: $localize`Join Operator`,
  ariaAdvancedFilterBuilderList: $localize`Advanced Filter Builder List`,
  ariaAdvancedFilterBuilderOption: $localize`Option`,
  ariaAdvancedFilterBuilderValueP: $localize`Value`,
  ariaAdvancedFilterInput: $localize`Advanced Filter Input`,
  ariaChartMenuClose: $localize`Close Chart Edit Menu`,
  ariaChartSelected: $localize`Selected`,
  ariaChecked: $localize`checked`,
  ariaColumn: $localize`Column`,
  ariaColumnFiltered: $localize`Column Filtered`,
  ariaColumnGroup: $localize`Column Group`,
  // ARIA Labels for the Side Bar
  ariaColumnPanelList: $localize`Column List`,
  ariaColumnSelectAll: $localize`Toggle All Columns Visibility`,
  ariaDateFilterInput: $localize`Date Filter Input`,
  ariaDefaultListName: $localize`List`,
  // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
  ariaDropZoneColumnComponentAggFuncSeparator: $localize` of `,
  ariaDropZoneColumnComponentDescription: $localize`Press DELETE to remove`,
  ariaDropZoneColumnComponentSortAscending: $localize`ascending`,
  ariaDropZoneColumnComponentSortDescending: $localize`descending`,
  ariaDropZoneColumnGroupItemDescription: $localize`Press ENTER to sort`,
  ariaDropZoneColumnValueItemDescription: $localize`Press ENTER to change the aggregation type`,
  ariaFilterColumn: $localize`Press CTRL ENTER to open filter`,
  ariaFilterColumnsInput: $localize`Filter Columns Input`,
  ariaFilterFromValue: $localize`Filter from value`,
  ariaFilteringOperator: $localize`Filtering Operator`,
  ariaFilterInput: $localize`Filter Input`,
  ariaFilterList: $localize`Filter List`,
  ariaFilterMenuOpen: $localize`Open Filter Menu`,
  ariaFilterPanelList: $localize`Filter List`,
  ariaFilterToValue: $localize`Filter to value`,
  ariaFilterValue: $localize`Filter Value`,
  ariaHeaderSelection: $localize`Column with Header Selection`,
  ariaHidden: $localize`hidden`,
  ariaIndeterminate: $localize`indeterminate`,
  ariaInputEditor: $localize`Input Editor`,
  ariaLabelAdvancedFilterAutocomplete: $localize`Advanced Filter Autocomplete`,
  ariaLabelAdvancedFilterBuilderAddField: $localize`Advanced Filter Builder Add Field`,
  ariaLabelAdvancedFilterBuilderColumnSelectField: $localize`Advanced Filter Builder Column Select Field`,
  ariaLabelAdvancedFilterBuilderJoinSelectField: $localize`Advanced Filter Builder Join Operator Select Field`,
  ariaLabelAdvancedFilterBuilderOptionSelectField: $localize`Advanced Filter Builder Option Select Field`,
  ariaLabelAggregationFunction: $localize`Aggregation Function`,
  ariaLabelCellEditor: $localize`Cell Editor`,
  ariaLabelColumnFilter: $localize`Column Filter`,
  ariaLabelColumnMenu: $localize`Column Menu`,
  ariaLabelContextMenu: $localize`Context Menu`,
  ariaLabelDialog: $localize`Dialog`,
  // aria labels for async context menus
  ariaLabelLoadingContextMenu: $localize`Loading Context Menu`,
  ariaLabelRichSelectDeleteSelection: $localize`Press DELETE to deselect item`,
  ariaLabelRichSelectDeselectAllItems: $localize`Press DELETE to deselect all items`,
  // aria labels for rich select
  ariaLabelRichSelectField: $localize`Rich Select Field`,
  ariaLabelRichSelectToggleSelection: $localize`Press SPACE to toggle selection`,
  ariaLabelSelectField: $localize`Select Field`,
  ariaLabelSubMenu: $localize`SubMenu`,
  ariaLabelTooltip: $localize`Tooltip`,
  ariaMenuColumn: $localize`Press ALT DOWN to open column menu`,
  ariaPageSizeSelectorLabel: $localize`Page Size`,
  ariaPivotDropZonePanelLabel: $localize`Column Labels`,
  ariaRowDeselect: $localize`Press SPACE to deselect this row`,
  // ARIA Labels for Drop Zones
  ariaRowGroupDropZonePanelLabel: $localize`Row Groups`,
  ariaRowSelect: $localize`Press SPACE to select this row`,
  ariaRowSelectAll: $localize`Press Space to toggle all rows selection`,
  ariaRowSelectionDisabled: $localize`Row Selection is disabled for this row`,
  ariaRowToggleSelection: $localize`Press Space to toggle row selection`,
  ariaSearch: $localize`Search`,
  ariaSearchFilterValues: $localize`Search filter values`,
  ariaSkeletonCellLoading: $localize`Row data is loading`,
  ariaSkeletonCellLoadingFailed: $localize`Row failed to load`,
  ariaSortableColumn: $localize`Press ENTER to sort`,
  ariaToggleCellValue: $localize`Press SPACE to toggle cell value`,
  ariaToggleVisibility: $localize`Press SPACE to toggle visibility`,
  ariaUnchecked: $localize`unchecked`,
  ariaValuesDropZonePanelLabel: $localize`Values`,
  ariaVisible: $localize`visible`,
  august: $localize`August`,
  automatic: $localize`Automatic`,
  autoRotate: $localize`Auto Rotate`,
  autosizeAllColumns: $localize`Autosize All Columns`,
  autosizeThisColumn: $localize`Autosize This Column`,
  avg: $localize`Average`,
  axis: $localize`Axis`,
  axisType: $localize`Axis Type`,
  background: $localize`Background`,
  bar: $localize`Bar`,
  barChart: $localize`Bar`,
  barGroup: $localize`Bar`,
  before: $localize`Before`,
  blank: $localize`Blank`,
  blanks: $localize`(Blanks)`,
  blur: $localize`Blur`,
  bold: $localize`Bold`,
  boldItalic: $localize`Bold Italic`,
  bottom: $localize`Bottom`,
  boxPlot: $localize`Box Plot`,
  boxPlotTooltip: $localize`Box Plot`,
  bubble: $localize`Bubble`,
  bubbleTooltip: $localize`Bubble`,
  callout: $localize`Callout`,
  calloutLabels: $localize`Callout Labels`,
  cancelFilter: $localize`Cancel`,
  cap: $localize`Cap`,
  capLengthRatio: $localize`Length Ratio`,
  categories: $localize`Categories`,
  category: $localize`Category`,
  categoryAdd: $localize`Add a category`,
  categoryValues: $localize`Category Values`,
  chartAdvancedSettings: $localize`Advanced Settings`,
  chartDownload: $localize`Download Chart`,
  chartDownloadToolbarTooltip: $localize`Download Chart`,
  chartEdit: $localize`Edit Chart`,
  chartLink: $localize`Link to Grid`,
  chartLinkToolbarTooltip: $localize`Linked to Grid`,
  chartMenuToolbarTooltip: $localize`Menu`,
  chartRange: $localize`Chart Range`,
  chartSettingsToolbarTooltip: $localize`Menu`,
  chartStyle: $localize`Chart Style`,
  chartSubtitle: $localize`Subtitle`,
  chartTitle: $localize`Chart Title`,
  chartTitles: $localize`Titles`,
  chartUnlink: $localize`Unlink from Grid`,
  chartUnlinkToolbarTooltip: $localize`Unlinked from Grid`,
  chooseColumns: $localize`Choose Columns`,
  circle: $localize`Circle`,
  clearFilter: $localize`Clear`,
  collapseAll: $localize`Close All Row Groups`,
  color: $localize`Color`,
  column: $localize`Column`,
  columnChart: $localize`Column`,
  columnChooser: $localize`Choose Columns`,
  columnFilter: $localize`Column Filter`,
  columnGroup: $localize`Column`,
  columnLineCombo: $localize`Column & Line`,
  columnLineComboTooltip: $localize`Column & Line`,
  // Side Bar
  columns: $localize`Columns`,
  combinationChart: $localize`Combination`,
  combinationGroup: $localize`Combination`,
  connectorLine: $localize`Connector Line`,
  // Text Filter
  contains: $localize`Contains`,
  copy: $localize`Copy`,
  copyWithGroupHeaders: $localize`Copy with Group Headers`,
  copyWithHeaders: $localize`Copy With Headers`,
  count: $localize`Count`,
  cross: $localize`Cross`,
  crosshair: $localize`Crosshair`,
  crosshairLabel: $localize`Label`,
  crosshairSnap: $localize`Snap to Node`,
  csvExport: $localize`CSV Export`,
  ctrlC: $localize`Ctrl+C`,
  ctrlV: $localize`Ctrl+V`,
  ctrlX: $localize`Ctrl+X`,
  customCombo: $localize`Custom Combination`,
  customComboTooltip: $localize`Custom Combination`,
  cut: $localize`Cut`,
  data: $localize`Set Up`,
  dateFilter: $localize`Date Filter`,
  // Date Filter
  dateFormatOoo: $localize`yyyy-mm-dd`,
  december: $localize`December`,
  decimalSeparator: $localize`.`,
  defaultCategory: $localize`(None)`,
  diamond: $localize`Diamond`,
  direction: $localize`Direction`,
  donut: $localize`Donut`,
  donutTooltip: $localize`Donut`,
  durationMillis: $localize`Duration (ms)`,
  empty: $localize`Choose one`,
  enabled: $localize`Enabled`,
  endAngle: $localize`End Angle`,
  endsWith: $localize`Ends with`,
  equals: $localize`Equals`,
  excelExport: $localize`Excel Export`,
  expandAll: $localize`Expand All Row Groups`,
  export: $localize`Export`,
  false: $localize`False`,
  february: $localize`February`,
  fillOpacity: $localize`Fill Opacity`,
  filteredRows: $localize`Filtered`,
  // Number Filter & Text Filter
  filterOoo: $localize`Filter...`,
  filters: $localize`Filters`,
  first: $localize`First`,
  firstPage: $localize`First Page`,
  fixed: $localize`Fixed`,
  font: $localize`Font`,
  footerTotal: $localize`Total`,
  format: $localize`Customize`,
  greaterThan: $localize`Greater than`,
  greaterThanOrEqual: $localize`Greater than or equal to`,
  gridLines: $localize`Grid Lines`,
  // Header of the Default Group Column
  group: $localize`Group`,
  groupBy: $localize`Group by`,
  groupedAreaTooltip: $localize`Area`,
  groupedBar: $localize`Grouped`,
  groupedBarFull: $localize`Grouped Bar`,
  groupedBarTooltip: $localize`Grouped`,
  groupedColumn: $localize`Grouped`,
  groupedColumnFull: $localize`Grouped Column`,
  groupedColumnTooltip: $localize`Grouped`,
  groupedSeriesGroupType: $localize`Grouped`,
  // Group Column Filter
  groupFilterSelect: $localize`Select field:`,
  groupPadding: $localize`Group Padding`,
  groups: $localize`Row Groups`,
  heart: $localize`Heart`,
  heatmap: $localize`Heatmap`,
  heatmapTooltip: $localize`Heatmap`,
  height: $localize`Height`,
  hierarchicalChart: $localize`Hierarchical`,
  hierarchicalGroup: $localize`Hierarchical`,
  histogram: $localize`Histogram`,
  histogramBinCount: $localize`Bin count`,
  histogramChart: $localize`Histogram`,
  histogramFrequency: $localize`Frequency`,
  histogramTooltip: $localize`Histogram`,
  horizontal: $localize`Horizontal`,
  horizontalAxisTitle: $localize`Horizontal Axis Title`,
  innerRadius: $localize`Inner Radius`,
  inRange: $localize`Between`,
  inRangeEnd: $localize`To`,
  inRangeStart: $localize`From`,
  inside: $localize`Inside`,
  invalidColor: $localize`Color value is invalid`,
  invalidDate: $localize`Invalid Date`,
  invalidNumber: $localize`Invalid Number`,
  italic: $localize`Italic`,
  itemPaddingX: $localize`Item Padding X`,
  itemPaddingY: $localize`Item Padding Y`,
  itemSpacing: $localize`Item Spacing`,
  january: $localize`January`,
  july: $localize`July`,
  june: $localize`June`,
  labelPlacement: $localize`Placement`,
  labelRotation: $localize`Rotation`,
  labels: $localize`Labels`,
  last: $localize`Last`,
  lastPage: $localize`Last Page`,
  layoutHorizontalSpacing: $localize`Horizontal Spacing`,
  layoutVerticalSpacing: $localize`Vertical Spacing`,
  left: $localize`Left`,
  legend: $localize`Legend`,
  legendEnabled: $localize`Enabled`,
  length: $localize`Length`,
  // Number Filter
  lessThan: $localize`Less than`,
  lessThanOrEqual: $localize`Less than or equal to`,
  lineChart: $localize`Line`,
  lineDash: $localize`Line Dash`,
  lineDashOffset: $localize`Dash Offset`,
  lineGroup: $localize`Line`,
  lineTooltip: $localize`Line`,
  lineWidth: $localize`Line Width`,
  loadingError: $localize`ERR`,
  // Other
  loadingOoo: $localize`Loading...`,
  march: $localize`March`,
  markerPadding: $localize`Marker Padding`,
  markers: $localize`Markers`,
  markerSize: $localize`Marker Size`,
  markerStroke: $localize`Marker Stroke`,
  max: $localize`Max`,
  maxSize: $localize`Maximum Size`,
  may: $localize`May`,
  min: $localize`Min`,
  miniChart: $localize`Mini-Chart`,
  minSize: $localize`Minimum Size`,
  more: $localize`More`,
  navigator: $localize`Navigator`,
  nextPage: $localize`Next Page`,
  nightingale: $localize`Nightingale`,
  nightingaleTooltip: $localize`Nightingale`,
  noAggregation: $localize`None`,
  noDataToChart: $localize`No data available to be charted.`,
  noMatches: $localize`No matches`,
  none: $localize`None`,
  noPin: $localize`No Pin`,
  normal: $localize`Normal`,
  normalizedArea: $localize`100% Stacked`,
  normalizedAreaFull: $localize`100% Stacked Area`,
  normalizedAreaTooltip: $localize`100% Stacked`,
  normalizedBar: $localize`100% Stacked`,
  normalizedBarFull: $localize`100% Stacked Bar`,
  normalizedBarTooltip: $localize`100% Stacked`,
  normalizedColumn: $localize`100% Stacked`,
  normalizedColumnFull: $localize`100% Stacked Column`,
  normalizedColumnTooltip: $localize`100% Stacked`,
  normalizedLine: $localize`100% Stacked`,
  normalizedLineTooltip: $localize`100% Stacked`,
  normalizedSeriesGroupType: $localize`100% Stacked`,
  noRowsToShow: $localize`No Rows To Show`,
  notBlank: $localize`Not blank`,
  notContains: $localize`Does not contain`,
  notEqual: $localize`Does not equal`,
  november: $localize`November`,
  number: $localize`Number`,
  numberFilter: $localize`Number Filter`,
  october: $localize`October`,
  of: $localize`of`,
  offset: $localize`Offset`,
  offsets: $localize`Offsets`,
  orCondition: $localize`OR`,
  orientation: $localize`Orientation`,
  outside: $localize`Outside`,
  padding: $localize`Padding`,
  page: $localize`Page`,
  pageLastRowUnknown: $localize`?`,
  pageSizeSelectorLabel: $localize`Page Size:`,
  paired: $localize`Paired Mode`,
  parallel: $localize`Parallel`,
  paste: $localize`Paste`,
  perpendicular: $localize`Perpendicular`,
  pie: $localize`Pie`,
  pieChart: $localize`Pie`,
  pieGroup: $localize`Pie`,
  pieTooltip: $localize`Pie`,
  // Menu
  pinColumn: $localize`Pin Column`,
  pinLeft: $localize`Pin Left`,
  pinRight: $localize`Pin Right`,
  pivotChart: $localize`Pivot Chart`,
  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: $localize`Pivot Chart & Pivot Mode`,
  pivotChartRequiresPivotMode: $localize`Pivot Chart requires Pivot Mode enabled.`,
  // Charts
  pivotChartTitle: $localize`Pivot Chart`,
  // Pivoting
  pivotColumnGroupTotals: $localize`Total`,
  pivotColumnsEmptyMessage: $localize`Drag here to set column labels`,
  // columns tool panel
  pivotMode: $localize`Pivot Mode`,
  pivots: $localize`Column Labels`,
  plus: $localize`Plus`,
  polarAxis: $localize`Polar Axis`,
  polarAxisTitle: $localize`Polar Axis Title`,
  polarChart: $localize`Polar`,
  polarGroup: $localize`Polar`,
  polygon: $localize`Polygon`,
  position: $localize`Position`,
  positionRatio: $localize`Position Ratio`,
  predefined: $localize`Predefined`,
  preferredLength: $localize`Preferred Length`,
  previousPage: $localize`Previous Page`,
  radarArea: $localize`Radar Area`,
  radarAreaTooltip: $localize`Radar Area`,
  radarLine: $localize`Radar Line`,
  radarLineTooltip: $localize`Radar Line`,
  radialBar: $localize`Radial Bar`,
  radialBarTooltip: $localize`Radial Bar`,
  radialColumn: $localize`Radial Column`,
  radialColumnTooltip: $localize`Radial Column`,
  radiusAxis: $localize`Radius Axis`,
  radiusAxisPosition: $localize`Position`,
  rangeArea: $localize`Range Area`,
  rangeAreaTooltip: $localize`Range Area`,
  rangeBar: $localize`Range Bar`,
  rangeBarTooltip: $localize`Range Bar`,
  rangeChartTitle: $localize`Range Chart`,
  removeFromLabels: $localize`Remove \${variable} from labels`,
  removeFromValues: $localize`Remove \${variable} from values`,
  resetColumns: $localize`Reset Columns`,
  resetFilter: $localize`Reset`,
  reverseDirection: $localize`Reverse Direction`,
  right: $localize`Right`,
  // Row Drag
  rowDragRow: $localize`row`,
  rowDragRows: $localize`rows`,
  rowGroupColumnsEmptyMessage: $localize`Drag here to set row groups`,
  scatter: $localize`Scatter`,
  scatterGroup: $localize`X Y (Scatter)`,
  scatterTooltip: $localize`Scatter`,
  scrollingStep: $localize`Scrolling Step`,
  scrollingZoom: $localize`Scrolling`,
  searchOoo: $localize`Search...`,
  secondaryAxis: $localize`Secondary Axis`,
  sectorLabels: $localize`Sector Labels`,

  // Set Filter
  selectAll: $localize`(Select All)`,
  selectAllSearchResults: $localize`(Select All Search Results)`,
  selectedRows: $localize`Selected`,
  selectingZoom: $localize`Selecting`,
  september: $localize`September`,
  series: $localize`Series`,
  seriesAdd: $localize`Add a series`,
  seriesChartType: $localize`Series Chart Type`,
  seriesGroupType: $localize`Group Type`,
  seriesItemLabels: $localize`Item Labels`,
  seriesItemNegative: $localize`Negative`,
  seriesItemPositive: $localize`Positive`,
  seriesItems: $localize`Series Items`,
  seriesItemType: $localize`Item Type`,
  seriesLabels: $localize`Series Labels`,
  seriesPadding: $localize`Series Padding`,
  seriesType: $localize`Series Type`,
  setFilter: $localize`Set Filter`,
  settings: $localize`Chart`,
  shadow: $localize`Shadow`,
  shape: $localize`Shape`,
  size: $localize`Size`,
  sortAscending: $localize`Sort Ascending`,
  sortDescending: $localize`Sort Descending`,
  sortUnSort: $localize`Clear Sort`,
  spacing: $localize`Spacing`,
  specializedChart: $localize`Specialized`,
  specializedGroup: $localize`Specialized`,
  square: $localize`Square`,
  stackedArea: $localize`Stacked`,
  stackedAreaFull: $localize`Stacked Area`,
  stackedAreaTooltip: $localize`Stacked`,
  stackedBar: $localize`Stacked`,
  stackedBarFull: $localize`Stacked Bar`,
  stackedBarTooltip: $localize`Stacked`,
  stackedColumn: $localize`Stacked`,
  stackedColumnFull: $localize`Stacked Column`,
  stackedColumnTooltip: $localize`Stacked`,
  stackedLine: $localize`Stacked`,
  stackedLineTooltip: $localize`Stacked`,
  stackedSeriesGroupType: $localize`Stacked`,
  startAngle: $localize`Start Angle`,
  startsWith: $localize`Begins with`,
  statisticalChart: $localize`Statistical`,
  statisticalGroup: $localize`Statistical`,
  strokeColor: $localize`Line Color`,
  strokeOpacity: $localize`Line Opacity`,
  strokeWidth: $localize`Stroke Width`,
  // Enterprise Menu Aggregation and Status Bar
  sum: $localize`Sum`,
  sunburst: $localize`Sunburst`,
  sunburstTooltip: $localize`Sunburst`,
  switchCategorySeries: $localize`Switch Category / Series`,
  // Filter Titles
  textFilter: $localize`Text Filter`,
  thickness: $localize`Thickness`,
  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: $localize`,`,
  ticks: $localize`Ticks`,
  tile: $localize`Tile`,
  time: $localize`Time`,
  timeFormat: $localize`Time Format`,
  timeFormatDashesYYYYMMDD: $localize`YYYY-MM-DD`,
  timeFormatDotsDDMYY: $localize`DD.M.YY`,
  timeFormatDotsMDDYY: $localize`M.DD.YY`,
  timeFormatHHMMSS: $localize`HH:MM:SS`,
  timeFormatHHMMSSAmPm: $localize`HH:MM:SS AM/PM`,
  timeFormatSlashesDDMMYY: $localize`DD/MM/YY`,
  // Time formats
  timeFormatSlashesDDMMYYYY: $localize`DD/MM/YYYY`,
  timeFormatSlashesMMDDYY: $localize`MM/DD/YY`,
  timeFormatSlashesMMDDYYYY: $localize`MM/DD/YYYY`,
  timeFormatSpacesDDMMMMYYYY: $localize`DD MMMM YYYY`,
  title: $localize`Title`,
  titlePlaceholder: $localize`Chart Title`,
  to: $localize`to`,
  tooltips: $localize`Tooltips`,
  top: $localize`Top`,
  totalAndFilteredRows: $localize`Rows`,
  totalRows: $localize`Total Rows`,
  treemap: $localize`Treemap`,
  treemapTooltip: $localize`Treemap`,
  triangle: $localize`Triangle`,
  // Data types
  true: $localize`True`,
  ungroupAll: $localize`Un-Group All`,
  ungroupBy: $localize`Un-Group by`,
  valueAggregation: $localize`Value Aggregation`,
  valueColumnsEmptyMessage: $localize`Drag here to aggregate`,
  values: $localize`Values`,
  vertical: $localize`Vertical`,
  verticalAxisTitle: $localize`Vertical Axis Title`,
  waterfall: $localize`Waterfall`,
  waterfallTooltip: $localize`Waterfall`,
  weight: $localize`Weight`,
  whisker: $localize`Whisker`,
  width: $localize`Width`,
  xAxis: $localize`Horizontal Axis`,
  xOffset: $localize`X Offset`,
  xType: $localize`X Type`,
  xyChart: $localize`X Y (Scatter)`,
  xyValues: $localize`X Y Values`,
  yAxis: $localize`Vertical Axis`,
  yOffset: $localize`Y Offset`,
  zoom: $localize`Zoom`,
});
